import React from 'react';

export const Footer = () => {
  return <div className='text-center p-10 mt-10 border-t dark:border-gray-700 border-gray-200'>
      <h1>2022 Saitama ,Inc.</h1>
  </div>;
};
